// extracted by mini-css-extract-plugin
export default {"Container":"chart_Container__to92x","chat-wrapper":"chart_chat-wrapper__xhOyP","chart":"chart_chart__vR5bW","details":"chart_details__MURyn"};